export const MAX_STANDARDSGROUP_LINKTEXT_LENGTH = 50;
export const MAX_STANDARDSGROUP_DESCRIPTION_LENGTH = 1000;

export const STANDARDS_GROUP_ROOT_LOCAL_ID = Number.MIN_SAFE_INTEGER;

export const IMAGE_SIZE_SMALL = 24;
export const PRODUCT_IMAGE_SIZE = 56;
export const PRODUCT_IMAGE_SIZE_SMALL = 32;
export const PRODUCT_IMAGE_SIZE_MEDIUM = 40;

export const FOLDER_DEFAULT_COLOR = "text.secondary";
export const FOLDER_FEATURES_COLOR = "warning.main";

export const COMMODITY_PRODUCT_CLASS = "shicommodity";
export const BUNDLE_PRODUCT_CLASS = "shiconfigsystem";

